'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Icons = require('./Icons');

var _utils = require('./utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Input = function (_PureComponent) {
	_inherits(Input, _PureComponent);

	function Input(props) {
		_classCallCheck(this, Input);

		var _this = _possibleConstructorReturn(this, (Input.__proto__ || Object.getPrototypeOf(Input)).call(this, props));

		_this.componentDidUpdate = function (oldProps) {
			var _this$props = _this.props,
			    numericThousandSeparator = _this$props.numericThousandSeparator,
			    value = _this$props.value;

			if (numericThousandSeparator && oldProps.value !== value) {
				var valueFormated = _this.addSeparator(_this.props.value);
				_this.setState({ valueFormated: valueFormated });
			}
		};

		_this.onKeyPress = function (e) {
			var _this$props2 = _this.props,
			    onKeyPress = _this$props2.onKeyPress,
			    onEnterPress = _this$props2.onEnterPress;


			var datas = { keyCode: e.keyCode, key: e.key, event: e };
			if (e.key === 'Enter' && onEnterPress) onEnterPress(datas);

			if (onKeyPress) onKeyPress(datas);
		};

		_this.onFocus = function () {
			var onFocus = _this.props.onFocus;


			if (!_this.state.hasBeenFocused) _this.setState({ hasBeenFocused: true });
			_this.setState({ focus: true });

			if (onFocus) onFocus();
		};

		_this.onBlur = function () {
			var onBlur = _this.props.onBlur;


			_this.setState({ focus: false });

			if (onBlur) onBlur();
		};

		_this.addSeparator = function (value) {
			return value.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, " ");
		};

		_this.onChange = function (e) {
			var _this$props3 = _this.props,
			    onChange = _this$props3.onChange,
			    maxChars = _this$props3.maxChars,
			    numericThousandSeparator = _this$props3.numericThousandSeparator;


			var value = e.target.value;
			var dispatch = maxChars === -1 || value.length <= maxChars || value.length < _this.props.value.length;

			if (dispatch) {
				if (!numericThousandSeparator) return onChange({ value: value, type: "input" });

				var valueFormated = _this.addSeparator(value);
				_this.setState({ valueFormated: valueFormated });
				onChange({ value: value.replace(/\s/g, ''), type: "input" });
			}
		};

		_this.state = {
			hasBeenFocused: false,
			focus: false,
			valueFormated: _this.addSeparator(_this.props.value)
		};
		return _this;
	}

	_createClass(Input, [{
		key: 'render',
		value: function render() {
			var _props = this.props,
			    required = _props.required,
			    value = _props.value,
			    label = _props.label,
			    errorText = _props.errorText,
			    errorRequiredText = _props.errorRequiredText,
			    error = _props.error,
			    useIcons = _props.useIcons,
			    lines = _props.lines,
			    className = _props.className,
			    maxChars = _props.maxChars,
			    iconLeft = _props.iconLeft,
			    disabled = _props.disabled,
			    noOutline = _props.noOutline,
			    size = _props.size,
			    labelAsOption = _props.labelAsOption;
			var _state = this.state,
			    hasBeenFocused = _state.hasBeenFocused,
			    focus = _state.focus;


			var hasError = error || hasBeenFocused && required && (!value || value === "") && !focus;
			var success = required && value !== "" && !hasError;
			var shouldDisplayError = hasError && (errorText || errorRequiredText);

			var shrink = focus || value !== '';

			return _react2.default.createElement(
				'div',
				{
					className: (0, _classnames2.default)('bnc_field', 'bnc_field_input', 'bnc_field_input--' + size, className, {
						'bnc_field_input--icon': iconLeft,
						'bnc_field_input--icon-right': useIcons && (hasError || success),
						'bnc_field_input--has-label': label && label !== '',
						'bnc_field_input--shrink-label': shrink,
						'bnc_field_input--disabled': disabled,
						'bnc_field_input--error': hasError,
						'bnc_field_input--no-outline': noOutline,
						'bnc_field_input--multilines': lines > 1,
						'bnc_field_input--label-as-option': labelAsOption
					})
				},
				_react2.default.createElement(
					'label',
					null,
					label && label !== '' && _react2.default.createElement(
						'span',
						{ className: 'label' },
						label,
						required && _react2.default.createElement(
							'abbr',
							null,
							'*'
						)
					),
					_react2.default.createElement(
						'span',
						{ className: 'bnc_field_input_container' },
						lines > 1 ? this.renderTextarea() : this.renderInput(),
						useIcons && hasError && _react2.default.createElement(_Icons.Close, { className: 'icon icon--error' }),
						useIcons && success && _react2.default.createElement(_Icons.Check, { className: 'icon icon--success' }),
						iconLeft && _react2.default.createElement(
							'span',
							{ className: 'icon icon--left' },
							iconLeft
						)
					),
					shouldDisplayError && _react2.default.createElement(
						'span',
						{ className: 'error' },
						errorText || errorRequiredText
					),
					maxChars > -1 && this.renderLabelMaxChars()
				)
			);
		}
	}, {
		key: 'renderLabelMaxChars',
		value: function renderLabelMaxChars() {
			var _props2 = this.props,
			    value = _props2.value,
			    maxChars = _props2.maxChars,
			    maxCharsText = _props2.maxCharsText;


			var current = value.length;
			var remaining = maxChars - current;

			var sentence = maxCharsText.split('{0}').join(current.toString()).split('{1}').join(maxChars.toString()).split('{2}').join(remaining.toString());

			return _react2.default.createElement(
				'span',
				{ className: (0, _classnames2.default)('help-text', {
						'help-text--orange': remaining < 20,
						'help-text--red': remaining <= 0
					}) },
				sentence
			);
		}
	}, {
		key: 'renderInput',
		value: function renderInput() {
			var _state2 = this.state,
			    focus = _state2.focus,
			    valueFormated = _state2.valueFormated;
			var _props3 = this.props,
			    required = _props3.required,
			    value = _props3.value,
			    placeholder = _props3.placeholder,
			    disabled = _props3.disabled,
			    autoFocus = _props3.autoFocus,
			    style = _props3.style,
			    type = _props3.type,
			    numericThousandSeparator = _props3.numericThousandSeparator,
			    label = _props3.label,
			    onKeyPress = _props3.onKeyPress,
			    onEnterPress = _props3.onEnterPress;

			var shrink = !label || label === '' || focus || value !== '';

			var eventProps = Object.assign({}, onKeyPress || onEnterPress ? { onKeyDown: this.onKeyPress } : null);

			return _react2.default.createElement('input', _extends({
				autoFocus: autoFocus,
				style: style,
				required: required,
				type: numericThousandSeparator ? 'text' : type,
				value: numericThousandSeparator ? valueFormated : value,
				placeholder: shrink ? placeholder : '',
				onChange: this.onChange,
				onFocus: this.onFocus,
				onBlur: this.onBlur,
				disabled: disabled
			}, eventProps));
		}
	}, {
		key: 'renderTextarea',
		value: function renderTextarea() {
			var focus = this.state.focus;
			var _props4 = this.props,
			    required = _props4.required,
			    value = _props4.value,
			    placeholder = _props4.placeholder,
			    lines = _props4.lines,
			    disabled = _props4.disabled,
			    style = _props4.style,
			    autoFocus = _props4.autoFocus,
			    label = _props4.label,
			    onKeyPress = _props4.onKeyPress,
			    onEnterPress = _props4.onEnterPress;

			var shrink = !label || label === '' || focus || value !== '';

			var eventProps = Object.assign({}, onKeyPress || onEnterPress ? { onKeyDown: this.onKeyPress } : null);

			return _react2.default.createElement('textarea', _extends({
				autoFocus: autoFocus,
				required: required,
				style: style,
				value: value,
				placeholder: shrink ? placeholder : '',
				rows: lines,
				onChange: this.onChange,
				onFocus: this.onFocus,
				onBlur: this.onBlur,
				disabled: disabled
			}, eventProps));
		}
	}]);

	return Input;
}(_react.PureComponent);

Input.defaultProps = {
	required: false,
	disabled: false,
	placeholder: '',
	label: '',
	error: false,
	errorText: '',
	errorRequiredText: '',
	useIcons: true,
	className: '',
	lines: 1,
	maxChars: -1,
	maxCharsText: '{0}/{1}',
	iconLeft: null,
	autoFocus: false,
	onEnterPress: null,
	onKeyPress: null,
	style: {},
	type: "text",
	noOutline: false,
	size: "regular",
	labelAsOption: false,
	numericThousandSeparator: false
};

Input.propTypes = {
	value: _propTypes2.default.string.isRequired,
	onChange: _propTypes2.default.func,
	onFocus: _propTypes2.default.func,
	onBlur: _propTypes2.default.func,
	label: _utils.StringOrReact,
	required: _propTypes2.default.bool,
	disabled: _propTypes2.default.bool,
	placeholder: _propTypes2.default.string,
	errorRequiredText: _utils.StringOrReact,
	error: _propTypes2.default.bool,
	errorText: _utils.StringOrReact,
	useIcons: _propTypes2.default.bool,
	lines: _propTypes2.default.number,
	className: _propTypes2.default.string,
	maxChars: _propTypes2.default.number,
	maxCharsText: _propTypes2.default.string,
	type: _propTypes2.default.string,
	iconLeft: _propTypes2.default.element,
	autoFocus: _propTypes2.default.bool,
	onEnterPress: _propTypes2.default.func,
	onKeyPress: _propTypes2.default.func,
	style: _propTypes2.default.object,
	noOutline: _propTypes2.default.bool,
	size: _propTypes2.default.string,
	labelAsOption: _propTypes2.default.bool,
	numericThousandSeparator: _propTypes2.default.bool
};

exports.default = Input;